import dayjs from "dayjs"
import React, { useEffect } from "react"
import { SectionHeader } from "../GlobalComponents/CommonComponents"
import { FormField } from "../GlobalComponents/Fields"
import "./index.css"
// import Textarea from './TextArea';
import { Box, InputAdornment, OutlinedInput, Typography } from "@mui/material"
import moment from "moment"
import { commonDateFormat } from "../../utils/constants"

const PersonalDetailsSection = (props) => {
  const {
    formData,
    handleChange,
    options,
    titleOption,
    expandedSections,
    onToggleExpand,
    expand,
  } = props.data
  const id = "personal-details"

  return (
    <Box
      style={{
        border: "0px solid blue",
        flex: 1,
        width: "100%",
        borderRadius: "5px",
      }}
    >
      <SectionHeader title="Personal Details" />
      {/* <CustomAccordion id={id}
                //     title="Personal Details" 
                //     expand={expand || expandedSections?.[id]}
                //     onToggleExpand={onToggleExpand}
                // > */}
      <Box className="patient-form-fields-container">
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="Title"
          name="title"
          value={formData.title}
          options={titleOption}
          onChange={handleChange}
          placeholder="Title"
          required={true}
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          placeholder="Enter your first name"
          errorMessage={`${formData.firstName?.length}/30 (minimum 3 characters)`}
          isError={formData.firstName?.length < 3}
          maxLength={30}
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          placeholder="Enter your last name"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Previous Last Name"
          name="previousLastName"
          value={formData.previousLastName}
          onChange={handleChange}
          placeholder="Enter your previous last name"
        />

        <div style={{ flex: 1 }}>
          <FormField
            deattach={true}
            labelClassName="patient-form-label"
            type="dropdown"
            label="Gender"
            options={options}
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            placeholder="Gender"
          />
        </div>

        <div style={{ flex: 1 }}>
          <FormField
            deattach={true}
            labelClassName="patient-form-label"
            type="date"
            label="Date of Birth"
            name="dateOfBirth"
            // value={formData.dateOfBirth || dayjs()}
            value={formData?.dateOfBirth && dayjs(moment(formData.dateOfBirth, commonDateFormat))}
            // onChange={handleChange}

            onChange={(newDate) => {
              if (newDate && newDate.isValid()) {
                handleChange({
                  target: {
                    name: "dateOfBirth", value:
                      moment(newDate.toDate()).format(commonDateFormat)
                  },
                })
              } else {
                console.log("Invalid date")
              }
            }}
          />
        </div>
      </Box>
      {/* </CustomAccordion> */}
    </Box>
  )
}

const ConsultantSection1 = (props) => {
  const { formData, handleChange, options } = props.data
  console.log("ConsultantSection1", formData, options, props.data)

  return (
    <Box
      style={{
        border: "0px solid blue",
        // flex: 1,
        width: "100%",
      }}
    >
      <SectionHeader title="Consultant" />
      <Box className="patient-form-fields-container">
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="Consultant"
          placeholder="Consultant"
          options={options}
          name="consultant"
          value={formData.consultant}
          onChange={handleChange}
        />
      </Box>
    </Box>
    // <CustomAccordion title="Consultant">
    //     <FormField
    //         type="dropdown"
    //         label="Consultant"
    //         options={options}
    //         name="consultant"
    //         value={formData.consultant}
    //         onChange={handleChange}
    //     />
    // </CustomAccordion>
  )
}

const AddressDetailsSection = (props) => {
  const { formData, handleChange, options, activeModal, setActiveModal } = props.data

  return (
    <Box
      style={{
        border: "0px solid blue",
        flex: 1,
        width: "100%",
        borderRadius: "5px",
      }}
    >
      <SectionHeader title="Address Details" />

      <Box className="patient-form-fields-container">
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Address 1"
          name="address1"
          value={formData.address1}
          onChange={handleChange}
          placeholder="Enter your address 1"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Address 2"
          name="address2"
          value={formData.address2}
          onChange={handleChange}
          placeholder="Enter your address 2"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Town"
          name="town"
          value={formData.town}
          onChange={handleChange}
          placeholder="Enter your town"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Country"
          name="country"
          value={formData.country}
          onChange={handleChange}
          placeholder="Enter your country"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Postcode"
          name="postcode"
          value={formData.postcode}
          onChange={handleChange}
          autoCapitalizeAllChars={true}
          placeholder="Enter your postcode"
        />
      </Box>
    </Box>
  )
}

// const OptometristDetailsSection = (props) => {

//     const { formData, handleChange, options, activeModal, setActiveModal, onCloseModal } = props.data
//     let modalData = {}
//     if (activeModal === "OptometristModal") {
//         modalData = {
//             // ...modalData,
//             onClose: onCloseModal,
//             onSubmit: onSubmit,
//             title: "Optometrist Modal",
//             show: true,
//         }
//     }

//     function onSubmit() {
//         console.log("onnasdfsadf", formData)
//         onCloseModal()
//     }

//     return (
//         <CustomAccordion title="Optometrist Details">
//             <FormField
//                 type="dropdown"
//                 label="Optometrist"
//                 options={options}
//                 name="optometrist"
//                 value={formData.optometrist}
//                 onChange={handleChange}
//             />

//             <CustomButton text="Add new optometrist"
//                 onClick={() => {
//                     setActiveModal("OptometristModal")
//                 }}
//                 style={{ margin: "0px" }}
//             />

//             {modalData.show && <BasicModal {...modalData}>
//                 <div style={{ padding: "20px" }}>

//                     <FormField
//                         label="Optometrist"
//                         name="newOptometrist"
//                         // style={{ margin: "20px 0px" }}
//                         value={formData.newOptometrist}
//                         onChange={handleChange}
//                     />
//                 </div>
//             </BasicModal>}

//         </CustomAccordion>
//     );
// };

const OtherInformationSection = (props) => {
  const { formData, handleChange, options, activeModal, setActiveModal } = props.data

  useEffect(() => {
    if (!formData.termsConditions) {
      handleChange({ target: { name: "termsConditions", value: options[1]?.value } })
    } else if (!formData.permissionToStoreData) {
      handleChange({
        target: { name: "permissionToStoreData", value: options[1]?.value },
      })
    }

  }, [formData?.termsConditions, formData?.permissionToStoreData])

  return (
    <Box>
      <SectionHeader title="Other Information" />
      <Box className="patient-form-fields-container">
        {/* <CustomAccordion title="Other Information"> */}
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="Terms and conditions agreed"
          name="termsConditions"
          options={options}
          value={formData.termsConditions}
          onChange={handleChange}
          placeholder="Agree to terms and conditions"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="Permission to store personal data agreed"
          name="permissionToStoreData"
          options={options}
          value={formData.permissionToStoreData}
          onChange={handleChange}
          placeholder="Agree to store personal data"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Occupation"
          name="occupation"
          value={formData.occupation}
          onChange={handleChange}
          placeholder="Enter your occupation"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Hobbies"
          name="hobbies"
          value={formData.hobbies}
          onChange={handleChange}
          placeholder="Enter your hobbies"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="Contact lens wearer"
          name="contactLens"
          value={formData.contactLens}
          options={options}
          onChange={handleChange}
          placeholder="Are you a contact lens wearer?"
        />

        {/* <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="CHI Number"
          name="chiNumber"
          value={formData.chiNumber}
          onChange={handleChange}
          placeholder="Enter your CHI Number"
        /> */}
        {/* </CustomAccordion> */}
      </Box>
    </Box>
  )
}

const ContactDetailsSection = (props) => {
  const { formData, handleChange, options, activeModal, setActiveModal } = props.data

  const onChangeNumber = (e) => {
    let value = e.target.value
    console.log("valuevalue123", value, /[^0-9]/.test(value))
    if (/[^0-9]/.test(value)) {
      return;
    }

    handleChange(e)
  }
  return (
    <Box>
      <SectionHeader title="Contact Details" />
      <Box className="patient-form-fields-container">
        {/* <CustomAccordion title="Contact Details"> */}
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Telephone (Home)"
          name="telephoneHome"
          value={formData.telephoneHome}
          onChange={handleChange}
          isNumberOnly={true}
          placeholder="Enter your home telephone number"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Telephone (Work)"
          name="telephoneWork"
          value={formData.telephoneWork}
          onChange={handleChange}
          isNumberOnly={true}
          placeholder="Enter your work telephone number"
        />

        {/* <OutlinedInput
          id="password"
          size="small"
          // type={showPassword ? "text" : "password"}
          // value={password}
          // onChange={(e) => setPassword(e.target.value)}
          sx={{ padding: "0px !important" }}
          endAdornment={
            <InputAdornment position="start">
              <span>+44</span>
            </InputAdornment>
          }
        /> */}

        <div className="field-container"
          style={{ display: "flex", alignItems: "center" }}
        >

          <Typography
            sx={{
              fontWeight: "bold",
              marginBottom: "5px",
              flexGrow: 1,
              boxSizing: "border-box",
            }}
            className="patient-form-label"
          >
            Telephone (Mobile)
          </Typography>

          <div style={{ flexGrow: 1, width: "100%" }}>

            <OutlinedInput
              id="phone-number"
              size="small"
              placeholder="Telephone (Mobile)"
              name="telephoneMobile"
              value={formData.telephoneMobile}
              inputProps={{
                maxLength: 15,
              }}
              onChange={onChangeNumber}
              sx={{ padding: "0px !important", width: "100%" }}
              startAdornment={
                <InputAdornment position="start">
                  <span style={{ marginLeft: "10px" }}>+44</span>
                </InputAdornment>
              }
            />

          </div>
        </div>

        {/* 

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Telephone (Mobile)"
          name="telephoneMobile"
          value={formData.telephoneMobile}
          onChange={handleChange}
          isNumberOnly={true}
          placeholder="Enter your mobile telephone number"
        /> */}

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email"
          autoCapitalize={false}
        />

        {/* </CustomAccordion> */}
      </Box>
    </Box>
  )
}



export {
  AddressDetailsSection,
  ConsultantSection1,
  ContactDetailsSection,
  OtherInformationSection,
  PersonalDetailsSection,
};
